/** Colors offered for a space (stored as hex; the sidebar and icons use their hue). */
export const SPACE_COLORS = [
  { key: "purple", hex: "#7C16F5" },
  { key: "blue", hex: "#2563EB" },
  { key: "sky", hex: "#0EA5E9" },
  { key: "teal", hex: "#14B8A6" },
  { key: "green", hex: "#16A34A" },
  { key: "amber", hex: "#F59E0B" },
  { key: "orange", hex: "#F97316" },
  { key: "red", hex: "#DC2626" },
  { key: "pink", hex: "#DB2777" },
  { key: "slate", hex: "#64748B" },
] as const;

export type SpaceColorKey = (typeof SPACE_COLORS)[number]["key"];

/** A stored color that isn't in the palette is kept as-is (offered as its hex). */
export function colorOptions(current: string, label: (key: SpaceColorKey) => string) {
  const options: { value: string; label: string }[] = SPACE_COLORS.map((c) => ({ value: c.hex, label: label(c.key) }));
  if (!options.some((o) => o.value.toLowerCase() === current.toLowerCase())) {
    options.unshift({ value: current, label: current });
  }
  return options;
}
